module.exports = {
      id: "googleplay-usage",
      viewBox: "0 0 135 40",
      url: __webpack_public_path__ + "svg-sprite-ef78f60979ae5731dcbbb0aa5aa86923.svg#googleplay",
      toString: function () {
        return this.url;
      }
    }